module.exports = __webpack_public_path__ + "static/img/bj0.dde71bb3.png";